/* eslint-disable jsx-a11y/anchor-has-content */
import { HOVER_CLASS_EXTENSION } from '@/constants/style';
import Link from 'next/link';
import React, { useMemo } from 'react';

type CustomLinkProps = {
  disableHover?: boolean;
} & React.HTMLProps<HTMLAnchorElement>;

const CustomLink: React.FC<CustomLinkProps> = ({ href, disableHover = false, ...rest }) => {
  const isInternalLink = href && href.startsWith('/');
  const isAnchorLink = href && href.startsWith('#');

  const className = useMemo(() => {
    if (disableHover) return rest.className;
    if (!rest.className) return HOVER_CLASS_EXTENSION;
    return `${rest.className} ${HOVER_CLASS_EXTENSION}`;
  }, [rest.className, disableHover]);

  if (isInternalLink) {
    return (
      <Link href={href}>
        <a {...rest} className={className} />
      </Link>
    );
  }

  if (isAnchorLink) {
    return <a href={href} {...rest} className={className} />;
  }

  return (
    <a target="_blank" rel="noopener noreferrer" href={href} {...rest} className={className} />
  );
};

export default CustomLink;
